export const messages = {
  finished: 'You made this!',
  finishedText: 'Continue to use Distribute and find your oun ideas to use it!',
  inProgress: 'Getting Started',
  inProgressText: 'Get the most out of your trial, complete your checklist!',
} as const;
